// extracted by mini-css-extract-plugin
module.exports = {"HaProxyLbCompareDashboard":"HaProxyLbCompareDashboard_0SBn8"};